import { IconSpriteChevronLeftThick, IconSpriteChevronRightThick } from '@propertyfinder/icons';
import { h } from 'preact';

import { configGetLanguage } from 'common/helper/config/get-language';

export const GalleryNavigationTemplate = (): h.JSX.Element => {
  const isRTL = configGetLanguage().isRtl;
  const PrevIcon = isRTL ? IconSpriteChevronRightThick : IconSpriteChevronLeftThick;
  const NextIcon = isRTL ? IconSpriteChevronLeftThick : IconSpriteChevronRightThick;

  return (
    <div>
      <div className='gallery-navigation__button gallery-navigation__button--prev'>
        <PrevIcon className='gallery-navigation__icon' />
      </div>
      <div className='gallery-navigation__button gallery-navigation__button--next'>
        <NextIcon className='gallery-navigation__icon' />
      </div>
    </div>
  );
};
